const PREFIX = 'vani.talk.session.';

export const TALK_LANGS = [
  { id: 'en', label: 'English' },
  { id: 'hi-en', label: 'Hindi' },
];

export function talkLanguage(code) {
  const raw = String(code || 'en').trim().toLowerCase();
  if (raw === 'hi-en' || raw === 'hi' || raw === 'hinglish' || raw === 'hindi') return 'hi-en';
  return 'en';
}

export function talkUserKey(user) {
  if (!user) return '';
  return String(user.id || user.user_id || user.email || '').trim();
}

export function talkSessionKey(userId) {
  return `${PREFIX}${String(userId || '').trim()}`;
}

export function loadTalkSession(userId, storage) {
  const store = storage || (typeof window !== 'undefined' ? window.localStorage : null);
  if (!store || !userId) return null;
  try {
    const raw = store.getItem(talkSessionKey(userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || !parsed.sessionId) return null;
    return {
      sessionId: String(parsed.sessionId),
      conversationId: parsed.conversationId ? String(parsed.conversationId) : '',
      language: talkLanguage(parsed.language),
      lastNote: parsed.lastNote || '',
      firstName: parsed.firstName || '',
      resumed: !!parsed.resumed,
      updatedAt: parsed.updatedAt || '',
      notes: Array.isArray(parsed.notes)
        ? parsed.notes.filter((item) => item && item.text).slice(0, 12)
        : (parsed.lastNote ? [{ id: 'last', text: String(parsed.lastNote), at: parsed.updatedAt || '' }] : []),
    };
  } catch (_) {
    return null;
  }
}

export function saveTalkSession(userId, payload, storage) {
  const store = storage || (typeof window !== 'undefined' ? window.localStorage : null);
  if (!store || !userId || !payload?.sessionId) return null;
  const next = {
    sessionId: String(payload.sessionId),
    conversationId: payload.conversationId ? String(payload.conversationId) : '',
    language: talkLanguage(payload.language),
    lastNote: payload.lastNote || '',
    firstName: payload.firstName || '',
    resumed: !!payload.resumed,
    notes: Array.isArray(payload.notes) ? payload.notes.filter((item) => item && item.text).slice(0, 12) : [],
    updatedAt: new Date().toISOString(),
  };
  try {
    store.setItem(talkSessionKey(userId), JSON.stringify(next));
  } catch (_) {
    /* private mode */
  }
  return next;
}

export function clearTalkSession(userId, storage) {
  const store = storage || (typeof window !== 'undefined' ? window.localStorage : null);
  if (!store || !userId) return;
  try {
    store.removeItem(talkSessionKey(userId));
  } catch (_) {
    /* ignore */
  }
}
